import { OfflineError } from "./api.ts";

/**
 * Send a client-side failure to the server log.
 *
 * On 27/09 a set could not be saved and nothing reached the journal: the
 * handler threw before any request went out. This is that missing trace.
 * Fire-and-forget, capped per page load, and silent when it fails itself.
 */

const MAX_REPORTS_PER_LOAD = 20;
let sent = 0;

export function reportError(error: unknown, context: Record<string, string> = {}): void {
  // Being offline is expected at the gym and already handled by the queue.
  if (error instanceof OfflineError) return;
  if (sent >= MAX_REPORTS_PER_LOAD) return;
  sent += 1;

  const payload = {
    message: (error instanceof Error ? error.message : String(error)).slice(0, 2000),
    stack: error instanceof Error ? (error.stack?.slice(0, 8000) ?? null) : null,
    url: location.pathname.slice(0, 500),
    userAgent: navigator.userAgent.slice(0, 500),
    context,
  };

  try {
    void fetch("/api/client-errors", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Reporting must never be the thing that breaks the screen.
  }
}
